import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import HightlightIconPath from '../assets/highlights.svg?react';
import RemoveIconPath from '../assets/delete.svg?react';

const Container = styled.span`
    position: relative;
    display: flex;
    align-items: center;
    height: 32px;
    width: 64px;
    background-color: var(--gray900);
    border-radius: 2px;
`;

const Arrow = styled.div`
    position: absolute;
    top: -5px;
    left: calc(50% - 6px);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-radius: 0 1px;

    border-bottom: 5px solid var(--gray900);
`;

const Divider = styled.div`
    height: 16px;
    width: 1px;
    background-color: var(--color-white);
    opacity: 0.3;
`;

const CustomHighlightIconPath = styled(HightlightIconPath)`
    ${({ theme }) => css`
        fill: ${theme.colors['surface-white']};
        height: 16px;
        width: 16px;

        &[disabled] {
            fill: ${theme.colors['surface-grey-700']};
        }
    `}
`;

const CustomRemoveIconPath = styled(RemoveIconPath)`
    ${({ theme }) => css`
        fill: ${theme.colors['surface-white']};
        height: 16px;
        width: 16px;

        &[disabled] {
            fill: ${theme.colors['surface-grey-700']};
        }
    `}
`;

const Button = styled.button`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 32px;
    background-color: transparent;
    outline: none;
    border: none;
    cursor: pointer;
    border-radius: 4px;
    padding: 0;

    &::-moz-focus-inner {
        border: 0;
    }

    &:focus {
        box-shadow: var(--outline);
    }

    &:active {
        box-shadow: none;
    }

    &:disabled {
        cursor: auto;
    }
`;

const PopUp = ({ canHighlight, canRemoveHightlight, onHighlight, onRemoveHighlight, isAppleMobile }) => {
    return (
        <Container>
            <Arrow />
            <Button
                disabled={!canHighlight}
                onClick={(e) => {
                    if (!isAppleMobile) {
                        e.target.blur();
                        onHighlight();
                    }
                }}
                onTouchStart={(e) => {
                    if (isAppleMobile) {
                        e.target.blur();
                        onHighlight();
                    }
                }}
            >
                <CustomHighlightIconPath disabled={!canHighlight} />
            </Button>
            <Divider />
            <Button
                disabled={!canRemoveHightlight}
                onClick={(e) => {
                    e.target.blur();
                    onRemoveHighlight();
                }}
            >
                <CustomRemoveIconPath disabled={!canRemoveHightlight} />
            </Button>
        </Container>
    );
};

PopUp.propTypes = {
    canHighlight: PropTypes.bool,
    canRemoveHightlight: PropTypes.bool,
    onHighlight: PropTypes.func,
    onRemoveHighlight: PropTypes.func,
    isAppleMobile: PropTypes.bool,
};

export default PopUp;
